import React from 'react'

function TrendingProductButton() {
    return (
        <>
            <a href='#' id='TrendingButton' type='button' 
            className="btn btn-sm btn btn-bg product-view-button"> More View</a>
        </>
    )
}

export default TrendingProductButton;
